import { useEffect, useState } from "react"
import { GenericInput } from "./Inputs"
import { StructureControls } from "./Controls"
import { loadDataset } from "../util/helpers"
import { Network } from 'junco/src/network'
import { RichSelect } from './RichSelect'

const Training = ({
  network,
  setNetwork,
  expectedOutputs,
  setExpectedOutputs,
  netStructure,
  setNetStructure,
  dataset,
  setDataset,
  trainingSets,
  trainingProgress,
  setTrainingProgress
}) => {  
  const nOutputs = network.nOutputs

  useEffect(() => {
    if(dataset) {
      // update network structure to have correct number of inputs and outputs
      const num_inputs = dataset.num_inputs
      const num_outputs = dataset.num_outputs
      const newStructureVar = [num_inputs].concat(netStructure.slice(1, -1)).concat([num_outputs])
      setNetStructure(newStructureVar)
    }
  }, [dataset])

  const handleExpectedChange = e => {
    var newEO = [...expectedOutputs]

    const i = e.target.dataset.i
    const val = Number(e.target.value)


    newEO[i] = val
    setExpectedOutputs(newEO)
  }

  const handleTrainingChange = i => {
      const trainingSet = trainingSets[i]
      loadDataset(trainingSet.path, json => setDataset(json))
  }

  const train = () => {
    const trainingWorker = new Worker(new URL('../workers/training.js', import.meta.url), {type: 'module'})
    trainingWorker.onerror = e => console.log(e)

    trainingWorker.postMessage({
      network: network.dump(),
      trainingData: dataset.data.train,
      trainingParams: {batch_size: 10, learning_rate: 5, epochs: 10000}
    })

    setTrainingProgress(true)

    trainingWorker.onmessage = (e) => {
      if(e.data.type == 'result') {
        setNetwork(Network.load(e.data.data))
      }
      else if(e.data.type == 'progress') {
        setTrainingProgress(e.data.data)
      }
    }
  }
  
  return (
    <div>
      <h2>Training</h2>
      <h3>Select training data</h3>
      <RichSelect options={trainingSets} handleChange={handleTrainingChange}/>
      <StructureControls
        netStructure={netStructure}
        setNetStructure={setNetStructure}
      ></StructureControls>
      <br></br>
      <button onClick={train}>Start Training</button>
      {trainingProgress && <TrainingProgress
        trainingProgress={trainingProgress}
        setTrainingProgress={setTrainingProgress}
      />}
    </div>
  )
}

const TrainingProgress = ({trainingProgress}) => {
  console.log(trainingProgress)
  if(trainingProgress.epoch + 1 >= trainingProgress.nEpochs) {
    return (
      <div>
        <p>Training Complete</p>
      </div>
    )
  }
  return (
    <div>
      <p>Training epoch {trainingProgress.epoch}</p>
    </div>
  )
}

export {
  Training
}